import * as angular from "angular";
import {IController} from "angular";
import {SyncActionModel} from "../../../commons/models/sync-action.model";

export class TasksOfflineActionsTableRowComponent implements IController {

  action: SyncActionModel;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes) {

  }

}

angular
  .module('bringoz.admin.tasks')
  .component('tasksOfflineActionsTableRow', {
    bindings: {
      action: '<'
    },
    template: require('./tasks-offline-actions-table-row.html').default,
    controller: TasksOfflineActionsTableRowComponent
  });
